import type { UserGroupSyncDetails, UserLogins } from "../../../../users/userTypes"

export enum CompanyUserDetailsType {
    USER = "user",
    ADMIN = "admin",
}

export type CompanyUserDetails = Readonly<{
    type: CompanyUserDetailsType
    id: number
    displayName: string
    displayInitials?: string
    email: string
    username?: string
    employeeId?: string
    userGroupName?: string
    departmentName?: string
    phone?: string
    language?: string
    syncDetails?: UserGroupSyncDetails
    logins?: UserLogins
    roles: ReadonlyArray<string>
}>
